export enum ActiveFocusItemName {
  HOME_GOAL = 'homeGoal',
  AWAY_GOAL = 'awayGoal',
  COMMENT = 'comment',
}

export interface KeyboardSliceState {
  activeFocusItem: ActiveFocusItemName | null;
}
